import React, { useCallback } from 'react';
import { View, TouchableOpacity } from 'react-native';
// `Alert` daqui, nao do react-native: no navegador o Alert do RN e um stub
// vazio e engole tudo em silencio (ver src/utils/appAlert.js). Em nativo e
// reexportacao direta - comportamento do app inalterado.
import { Alert } from '../../../utils/appAlert';
import { Image } from 'expo-image';
import { Text } from '../../../components/ui/AppText';
import { useToggleVideoLike } from '../hooks/useVideoMutations';
import { reportVideo } from '../services/communityVideosService';
import { styles } from './styles';

const formatDuration = (s) => {
  if (s == null) return null;
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, '0')}`;
};

const VideoCard = ({ video, liked, colors, onPress }) => {
  const toggleLike = useToggleVideoLike();
  const duration = formatDuration(video.durationSeconds);

  const handleLike = useCallback(
    () => toggleLike.mutate({ videoId: video.id, liked: !liked }),
    [toggleLike, video.id, liked]
  );

  const handleReport = useCallback(() => {
    Alert.alert('Denunciar vídeo', 'Deseja denunciar este vídeo como impróprio?', [
      { text: 'Cancelar', style: 'cancel' },
      { text: 'Denunciar', style: 'destructive', onPress: () => { reportVideo(video.id).catch(() => {}); } },
    ]);
  }, [video.id]);

  return (
    <TouchableOpacity style={styles.card} activeOpacity={0.85} onPress={() => onPress?.(video)}>
      <View style={styles.thumbWrap}>
        {video.thumbnailUrl ? (
          <Image source={{ uri: video.thumbnailUrl }} style={styles.thumb} contentFit="cover" transition={150} />
        ) : (
          <View style={[styles.thumb, styles.thumbPlaceholder]}>
            <Text style={styles.thumbPlaceholderIcon}>▶</Text>
          </View>
        )}
        {duration ? (
          <View style={styles.durationPill}>
            <Text style={styles.durationText}>{duration}</Text>
          </View>
        ) : null}
      </View>
      <View style={styles.cardBody}>
        <Image source={{ uri: video.author.avatarUrl }} style={styles.avatar} contentFit="cover" />
        <View style={styles.cardInfo}>
          <Text style={[styles.cardTitle, { color: colors?.textPrimary }]} numberOfLines={2}>
            {video.title}
          </Text>
          <Text style={[styles.cardMeta, { color: colors?.textSecondary }]} numberOfLines={1}>
            {video.author.name} • {video.viewsCount} views
          </Text>
          <View style={styles.cardActions}>
            <TouchableOpacity style={styles.likeBtn} onPress={handleLike} hitSlop={8}>
              <Text style={styles.likeIcon}>{liked ? '❤️' : '🤍'}</Text>
              <Text style={[styles.likeCount, { color: colors?.textSecondary }]}>{video.votesCount}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.reportBtn} onPress={handleReport} hitSlop={8}>
              <Text style={styles.reportIcon}>⚐</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default React.memo(VideoCard);
